module.exports = __webpack_public_path__ + "static/media/streamCross.552a5b4e.svg";